<template>
  <el-row>
    <el-row>
      <el-dialog
        title="录入溶剂参数信息"
        :visible.sync="showSolventList"
        :before-close="closeSolventList"
      >
        <el-row>
          <el-col :span="16" :offset="4">
            <el-form :model="form" ref="SolventList" :rules="rules">
              <el-table
                :data="form.tlc.solvents"
                :border="true"
                :header-cell-style="{
                  background: '#f3f6f9',
                  'text-align': 'center',
                }"
                :cell-style="{ 'text-align': 'center' }"
              >
                <el-table-column label="溶剂名称">
                  <template slot-scope="scope">
                    <span>{{ solventNo[scope.$index] }}</span>
                  </template>
                </el-table-column>
                <el-table-column label="溶剂">
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="'tlc.solvents.' + scope.$index + '.Solvent'"
                    >
                      <el-select
                        v-model="scope.row.Solvent"
                        style="margin-top: 25px"
                        @change="changeSolvent(scope.$index)"
                      >
                        <el-option
                          v-for="fp in flowPhaseList"
                          :key="fp.id"
                          :label="fp.solvent"
                          :value="fp.solvent"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="百分比">
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="'tlc.solvents.' + scope.$index + '.Percent'"
                      :rules="rules.Percent"
                    >
                      <el-input
                        v-model="scope.row.Percent"
                        type="mini"
                        style="margin-top: 25px"
                        @input="changePercent(scope.$index)"
                      >
                        <div slot="append">%</div>
                      </el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
              </el-table>
              <div style="margin-top: 15px">
                <div>备注</div>
                <el-input
                  placeholder="如含有添加剂等，请说明"
                  type="textarea"
                  autosize
                  clearable
                  style="margin-top: 5px"
                  v-model="form.tlc.remark"
                ></el-input>
              </div>
            </el-form>
          </el-col>
        </el-row>
        <el-row style="text-align: center; margin-top: 20px">
          <el-button type="primary" @click="finishSolvent">完成</el-button>
        </el-row>
      </el-dialog>
    </el-row>
    <el-row>
      <el-form label-width="120px" :model="form" :rules="formRules" ref="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="方法: ">
              <el-select v-model="form.type" size="mini" @change="changeType">
                <el-option
                  v-for="item in methodType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="form.type === 0">
          <el-col :span="8">
            <el-form-item label="TLC类型">
              <el-select
                v-model="form.tlc.label"
                size="mini"
                @change="updateTlCLabel"
              >
                <el-option
                  v-for="item in TLCType"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="展开剂信息:">
              <el-button type="primary" size="small" @click="clickSolventDialog"
                >设置</el-button
              >
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="TLC图片:"
              style="display: flex"
              label-width="auto"
            >
              <el-upload
                class="upload-demo"
                action="#"
                :limit="1"
                :auto-upload="false"
                list-type="picture"
                :on-change="changeTLCFile"
                :file-list="tlcPngs"
                :on-remove="handleTLCRemove"
                accept=".jpg,.png"
              >
                <el-button type="primary" size="mini">上传</el-button>
                <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
              </el-upload>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="form.type === 1" :gutter="50">
          <el-row>
            <el-col :span="8">
              <el-form-item
                label="名称:"
                prop="hplc.flashColumn.analysis_column"
              >
                <el-input
                  v-model="form.hplc.flashColumn.analysis_column"
                  size="mini"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="流速:" prop="hplc.flashColumn.flow_rate">
                <el-input v-model="form.hplc.flashColumn.flow_rate" size="mini"
                  ><template slot="append">ml/min</template></el-input
                >
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                label="填料粒径:"
                prop="hplc.flashColumn.particle_diameter"
              >
                <el-input
                  v-model="form.hplc.flashColumn.particle_diameter"
                  size="mini"
                  ><template slot="append">μm</template></el-input
                >
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item
                label="内径:"
                prop="hplc.flashColumn.inner_diameter"
              >
                <el-input
                  v-model="form.hplc.flashColumn.inner_diameter"
                  size="mini"
                  ><template slot="append">mm</template></el-input
                >
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="长度:" prop="hplc.flashColumn.length">
                <el-input v-model="form.hplc.flashColumn.length" size="mini"
                  ><template slot="append">mm</template></el-input
                >
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <el-form-item label="流动相A：">
                <el-select
                  v-model="form.hplc.flowA"
                  size="mini"
                  @change="changeFlowA"
                >
                  <el-option
                    v-for="item in FlowPhase"
                    :key="item.id"
                    :label="item.solvent"
                    :value="item.solvent"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="流动相B：">
                <el-select
                  v-model="form.hplc.flowB"
                  size="mini"
                  @change="changeFlowB"
                >
                  <el-option
                    v-for="item in FlowPhase"
                    :key="item.id"
                    :label="item.solvent"
                    :value="item.solvent"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="HPLC图片:">
                <el-upload
                  class="upload-demo"
                  action="#"
                  :limit="1"
                  :auto-upload="false"
                  list-type="picture"
                  :on-change="changeHPLCFile"
                  :file-list="hplcPngs"
                  :on-remove="handleHTLCRemove"
                  accept=".jpg,.png"
                >
                  <el-button type="primary" size="mini">上传</el-button>
                  <div slot="tip" class="el-upload__tip">
                    只能上传jpg/png文件
                  </div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-row>
      </el-form>
    </el-row>
  </el-row>
</template>

<script>
import { mapActions } from "vuex";
export default {
  name: "InputResCondition",
  data() {
    var flashColumn = (rule, value, callback) => {
      if (value === "") {
        callback();
      } else if (!Number(value) && Number(value) !== 0) {
        callback(new Error("请输入数字"));
      } else if (/(^-?[1-9]([0-9]*)$|^-?[0-9]$)/.test(value)) {
        if (Math.trunc(value) > 9999) {
          callback(new Error("整数部分不超过四位"));
        } else if (Math.trunc(value) <= 0) {
          callback(new Error("请输入正数"));
        } else {
          callback();
        }
      } else {
        if (Math.trunc(value.toString().split(".")[0]) > 9999) {
          callback(new Error("整数部分不超过四位"));
        } else if (value.toString().split(".")[1] > 99) {
          callback(new Error("小数部分不超过两位"));
        } else if (value.toString().split(".")[0] < 0) {
          callback(new Error("请输入正数"));
        } else {
          callback();
        }
      }
    };
    return {
      rules: {
        Percent: {
          validator: (rule, value, callback) => {
            if (value === "") {
              callback();
            } else if (!Number(value) && Number(value) !== 0) {
              callback(new Error("请输入数字"));
            } else if (Math.trunc(value) < 0) {
              callback(new Error("请输入正数"));
              this.$message("请输入正数");
            } else if (/^[0-9]*[1-9][0-9]*$/.test(Number(value)) == false) {
              this.$message("请输入正整数");
            }
            if (Number(value) > 100) {
              callback(new Error("最大值不能超过100"));
              this.$message("最大值不能超过100");
            } else {
              callback();
            }
          },
          trigger: "blur",
        },
      },
      formRules: {
        "hplc.flashColumn.analysis_column": [
          {
            min: 1,
            max: 255,
            message: "长度在 1 到 255 个字符",
            trigger: "blur",
          },
        ],
        "hplc.flashColumn.flow_rate": [
          { validator: flashColumn, trigger: "blur" },
        ],
        "hplc.flashColumn.particle_diameter": [
          { validator: flashColumn, trigger: "blur" },
        ],
        "hplc.flashColumn.inner_diameter": [
          { validator: flashColumn, trigger: "blur" },
        ],
        "hplc.flashColumn.length": [
          { validator: flashColumn, trigger: "blur" },
        ],
      },
      solventNo: ["溶剂A", "溶剂B"],
      // flowPhaseTags: ['流动相A:','流动相B:','流动相C:'],
      username: this.$store.state.username,
      showSolventList: false,
      showGradientDialog: false,
      flowPhaseShow: [],
      flowPhaseValue: "",
      form: {
        methodType: 1,
        tlc: {
          tlc: 1, //1: 氧化铝 2:C18
          solvents: [
            {
              Solvent: "",
              Percent: "",
              SolventEn: "",
              Polarity: "",
            },
            {
              Solvent: "",
              Percent: "",
              SolventEn: "",
              Polarity: "",
            },
          ], //展开剂
          remark: "", //备注
          tlcPic: "", //TLC图片
        },
        hplc: {
          hplc: {
            flashColumn: {
              type: "", //1:C18  2:CB  3:硅胶  4:氨基  5:HILIC
              analysis_column: "",
              flow_rate: "",
              particle_diameter: "",
              inner_diameter: "",
              length: "",
            },
            flowPhase: ["", ""], //1: 水  2: 乙腈
            hplcPic: "", //hplc图片
            flowA: "",
            flowB: "",
            hplcflowA: [],
            hplcflowB: [],
          },
        },
      },
      
      tlcPngs: [],
      hplcPngs: [],
      /**
       * 区分分析方法
       * */
      methodType: this.$store.state.sepaMethods.analysisMethodType,
      /**
       * TLC薄层板类别
       * */
      TLCType: this.$store.state.sepaMethods.TLCType,
      /**
       * 色谱柱填料类别
       * */
      columnFillerType: this.$store.state.sepaMethods.columnFillerType,
      FlowPhase: [],
    };
  },
  methods: {
    closeSolventList() {
      //  this.$refs['SolventList'].resetFields()
      this.showSolventList = false;
    },
    finishSolvent() {
      console.log("this.form.tlc", this.form.tlc);
      this.showSolventList = false;
    },
    resetForm() {
      this.form = {
        type: 0,
        methodType: 1,
        hplc: {
          flashColumn: {
            flow_rate: "",
            analysis_column: "",
            particle_diameter: "",
            inner_diameter: "",
            length: "",
            hplcPic: "",
            flowA: "",
            flowB: "",
            hplcflowA: [],
            hplcflowB: [],
          },
        },
        tlc: {
          label: "",
          solvents: [
            {
              Solvent: "",
              Percent: "",
              SolventEn: "",
              Polarity: "",
            },
            {
              Solvent: "",
              Percent: "",
              SolventEn: "",
              Polarity: "",
            },
          ],
          tlcPic: "",
          remark: "",
        },
      };
      this.tlcPngs = [];
      this.hplcPngs = [];
    },
    submitForm() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          this.$store.commit("updateResCondition", true);
        } else {
          this.$store.commit("updateResCondition", false);
        }
      });
    },
    changeSolvent(index) {
      this.form.tlc.solvents[index].SolventEn = this.flowPhaseList.find(
        (item) => item.solvent === this.form.tlc.solvents[index].Solvent
      ).solvent_en;
      this.form.tlc.solvents[index].Polarity = this.flowPhaseList.find(
        (item) => item.solvent === this.form.tlc.solvents[index].Solvent
      ).polarity;
    },
    changeFlowA() {
      let data = [];
      data.push({
        Solvent: this.FlowPhase.find(
          (item) => item.solvent === this.form.hplc.flowA
        ).solvent,
        id: this.FlowPhase.find((item) => item.solvent === this.form.hplc.flowA)
          .id,
        Polarity: this.FlowPhase.find(
          (item) => item.solvent === this.form.hplc.flowA
        ).polarity,
        Density: this.FlowPhase.find(
          (item) => item.solvent === this.form.hplc.flowA
        ).density,
        eluent_channel: 0,
      });
      this.form.hplc.hplcflowA = data;
    },
    changeFlowB() {
      let data = [];
      data.push({
        Solvent: this.FlowPhase.find(
          (item) => item.solvent === this.form.hplc.flowB
        ).solvent,
        id: this.FlowPhase.find((item) => item.solvent === this.form.hplc.flowB)
          .id,
        Polarity: this.FlowPhase.find(
          (item) => item.solvent === this.form.hplc.flowB
        ).polarity,
        Density: this.FlowPhase.find(
          (item) => item.solvent === this.form.hplc.flowB
        ).density,
        eluent_channel: 1,
      });
      this.form.hplc.hplcflowB = data;
    },
    valueChange() {
      this.$forceUpdate();
    },
    changePercent(index) {
      if (index === 0) {
        this.form.tlc.solvents[1].Percent = (
          100 - this.form.tlc.solvents[0].Percent
        ).toFixed(0);
      } else {
        this.form.tlc.solvents[0].Percent = (
          100 - this.form.tlc.solvents[1].Percent
        ).toFixed(0);
      }
    },
    changeType() {
      if (this.form.type === 1) {
        this.form.hplc = {
          flashColumn: {
            type: "", //1:C18  2:CB  3:硅胶  4:氨基  5:HILIC
            analysis_column: "",
            flow_rate: "",
            particle_diameter: "",
            inner_diameter: "",
            length: "",
          },
          flowPhase: ["", ""], //1: 水  2: 乙腈
          hplcPic: "", //hplc图片
        };
      } else if (this.form.type === 0) {
        this.form.tlc = {
          tlc: 1, //1: 氧化铝 2:C18
          solvents: [
            {
              Solvent: "",
              Percent: "",
              SolventEn: "",
              Polarity: "",
            },
            {
              Solvent: "",
              Percent: "",
              SolventEn: "",
              Polarity: "",
            },
          ], //展开剂
          tlcPic: "", //TLC图片
        };
      }
    },
    clickSolventDialog() {
      this.showSolventList = true;
      this.flowPhaseList = this.$store.state.flowPhaseList;
      // console.log(this.form.tlc);
    },
    deleteSolventRow: function (index) {
      if (this.form.tlc.solvents.length >= 2) {
        this.form.tlc.solvents.splice(index, 1);
      }
    },
    /**
     * 更新TLC的内容
     * */
    updateTlCLabel: function () {
      // if (this.form.tlc.tlc == 3) {
      //     this.form.tlc.tlcLabel = "";
      // }
    },
    /**
     * 图片上传(TLC , HPLC)
     * */
    getBase64(file) {
      return new Promise(function (resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function () {
          imgResult = reader.result;
        };
        reader.onerror = function (error) {
          reject(error);
        };
        reader.onloadend = function () {
          resolve(imgResult);
        };
      });
    },
    readySubmitFile(fileList) {
      //将准备提交的多张图片转为base64
      let _this = this;
      if (!(fileList instanceof Array) || fileList.length <= 0) {
        return false;
      }
      _this.fileMessage.fileNameArr = [];
      _this.fileMessage.fileBase64Arr = [];
      for (let i = 0; i < fileList.length; i++) {
        _this.fileMessage.fileNameArr.push(fileList[i].name);
        _this.getBase64(fileList[i].raw).then(
          (res) => {
            console.log("222", res);
            _this.fileMessage.fileBase64Arr.push(res);
          },
          (err) => {
            console.log(err, "转码失败");
          }
        );
      }
      return true;
    },
    changeTLCFile(file, fileList) {
      this.form.tlc.tlcPic = "";
      fileList.forEach(async (item) => {
        const img = await this.getBase64(item.raw);
        let url = img.substring(img.indexOf(",") + 1).replaceAll(" ", "+");
        this.form.tlc.tlcPic = url;
      });
    },
    handleTLCRemove() {
      this.form.tlc.tlcPic = "";
    },
    changeHPLCFile(file, fileList) {
      this.form.hplc.hplcPic = "";
      fileList.forEach(async (item) => {
        const img = await this.getBase64(item.raw);
        let url = img.substring(img.indexOf(",") + 1).replaceAll(" ", "+");
        this.form.hplc.hplcPic = url;
      });
    },
    handleHTLCRemove() {
      this.form.hplc.hplcPic = "";
    },
    ...mapActions("sepaMethods", ["updatePurityResConfirmation"]),
  },
  created() {
    this.form = this.$store.state.sepaMethods.purityResConfirmation;
    if (this.form.tlc.tlcPic != "" && this.form.tlc.tlcPic != undefined) {
      this.tlcPngs = [
        {
          name: "TLC图片",
          url: `data:image/png;base64,${this.form.tlc.tlcPic}`,
        },
      ];
    }
    if (this.form.hplc != undefined) {
      if (this.form.hplc.hplcPic != "" && this.form.hplc.hplcPic != undefined) {
        this.hplcPngs = [
          {
            name: "HPLC图片",
            url: `data:image/png;base64,${this.form.hplc.hplcPic}`,
          },
        ];
      }
    }
    this.$api.get("/datacenter/getSolventList ", {}, (res) => {
      if (res.data.code == 200) {
        this.FlowPhase = res.data.data;
        this.$store.commit("updateFlowPhaseList", res.data.data);
      } else {
        this.$message.error("获取溶剂列表失败");
      }
    });
  },
  watch: {
    form: {
      handler() {
        this.updatePurityResConfirmation(this.form);
      },
      deep: true,
    },
  },
};
</script>

<style scoped></style>
